import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function About() {
  const [activeTab, setActiveTab] = useState<'brand' | 'reputation' | 'contact'>('brand');

  const tabs = [
    { key: 'brand' as const, label: '品牌介绍', icon: 'ri-building-line' },
    { key: 'reputation' as const, label: '信誉保障', icon: 'ri-shield-check-line' },
    { key: 'contact' as const, label: '联系我们', icon: 'ri-customer-service-line' },
  ];

  const organizationStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '金沙娱乐',
    url: 'https://www.jinshaentertainment.com',
    description: '金沙娱乐官方平台 – 顶级在线娱乐平台',
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '400-888-9999',
        contactType: 'customer service',
        availableLanguage: 'Chinese',
        areaServed: 'CN',
      },
      {
        '@type': 'ContactPoint',
        email: 'service@jinshaentertainment.com',
        contactType: 'customer service',
      },
    ],
    sameAs: [
      'https://weibo.com/jinshaentertainment',
      'https://t.me/jinshaentertainment',
    ],
  };

  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '金沙娱乐平台是否安全可靠？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '金沙娱乐采用国际领先的256位SSL加密技术和多重身份验证系统，所有游戏均使用经过认证的随机数生成器（RNG），确保平台的安全性和公平性。平台定期接受第三方独立机构的审计，并获得多项行业权威认证。',
        },
      },
      {
        '@type': 'Question',
        name: '金沙娱乐提供哪些游戏类型？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '金沙娱乐提供电子游戏（老虎机、桌面游戏等）、真人荷官（百家乐、轮盘、骰宝等）、体育竞技（足球、篮球、网球等）、彩票游戏（时时彩、快乐8等）和电竞竞技（LOL、DOTA2、CS:GO等）五大游戏类型，满足不同玩家的娱乐需求。',
        },
      },
    ],
  };

  const webPageStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 – 金沙娱乐官方平台',
    description: '了解金沙娱乐的品牌故事、信誉保障和联系方式。金沙娱乐是您值得信赖的顶级在线娱乐平台。',
    url: 'https://www.jinshaentertainment.com/about',
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationStructuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageStructuredData) }}
      />
      <Navbar />
      <main className="pt-20">
        <div className="w-full px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>

        <section className="w-full px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-2">
              关于我们
            </h1>
            <p className="text-sm text-foreground-500 mb-8">
              了解金沙娱乐的品牌故事、信誉保障和联系方式
            </p>

            <div className="flex items-center gap-1 bg-background-900 rounded-full p-1 mb-8 border border-background-700/30">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    activeTab === tab.key
                      ? 'bg-primary-500 text-background-950'
                      : 'text-foreground-400 hover:text-foreground-200'
                  }`}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${tab.icon} text-xs`}></i>
                  </div>
                  {tab.label}
                </button>
              ))}
            </div>

            {activeTab === 'brand' && (
              <div className="space-y-8 animate-in fade-in duration-300">
                <div className="bg-background-900 rounded-xl border border-background-700/30 p-6 md:p-8">
                  <h2 className="text-xl font-heading font-bold text-foreground-50 mb-4">品牌故事</h2>
                  <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
                    金沙娱乐成立于2015年，总部位于菲律宾马尼拉，是亚洲领先的在线娱乐平台之一。自成立以来，金沙娱乐始终致力于为全球玩家提供安全、公平、优质的一站式在线娱乐体验。
                  </p>
                  <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
                    我们的名字"金沙"寓意着金色的沙滩，象征着财富与幸运。正如金色的沙滩汇聚了无数珍贵的沙粒，金沙娱乐也汇聚了全球最优质的游戏资源、最先进的技术和最专业的服务团队。
                  </p>
                  <p className="text-sm md:text-base text-foreground-400 leading-relaxed">
                    经过近十年的发展，金沙娱乐已积累了超过200万注册用户，业务覆盖东南亚、东亚、中东等多个地区。我们拥有超过500款精品游戏，与全球20多家顶级游戏开发商建立了战略合作关系。
                  </p>
                </div>

                <div className="bg-background-900 rounded-xl border border-background-700/30 p-6 md:p-8">
                  <h2 className="text-xl font-heading font-bold text-foreground-50 mb-4">核心优势</h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-primary-500/10">
                        <i className="ri-shield-check-line text-primary-400 text-lg"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">安全保障</h3>
                        <p className="text-xs text-foreground-500 mt-1 leading-relaxed">银行级加密技术与多重身份验证，确保用户信息和资金安全。</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-primary-500/10">
                        <i className="ri-gamepad-line text-primary-400 text-lg"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">丰富游戏</h3>
                        <p className="text-xs text-foreground-500 mt-1 leading-relaxed">500+精品游戏，涵盖电子、真人、体育、彩票、电竞五大类型。</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-primary-500/10">
                        <i className="ri-customer-service-2-line text-primary-400 text-lg"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">专属客服</h3>
                        <p className="text-xs text-foreground-500 mt-1 leading-relaxed">7×24小时多语言客服支持，快速响应，专业解答。</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-primary-500/10">
                        <i className="ri-flashlight-line text-primary-400 text-lg"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">快速支付</h3>
                        <p className="text-xs text-foreground-500 mt-1 leading-relaxed">支持多种支付方式，存款秒到账，提款快速处理，30分钟内到账。</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-background-900 rounded-xl border border-background-700/30 p-6 md:p-8">
                  <h2 className="text-xl font-heading font-bold text-foreground-50 mb-4">发展历程</h2>
                  <div className="space-y-4">
                    <div className="flex gap-4">
                      <div className="shrink-0 w-16 text-sm font-heading font-bold text-primary-400">2015</div>
                      <div className="text-sm text-foreground-400">金沙娱乐正式成立，获得菲律宾PAGCOR博彩牌照</div>
                    </div>
                    <div className="flex gap-4">
                      <div className="shrink-0 w-16 text-sm font-heading font-bold text-primary-400">2017</div>
                      <div className="text-sm text-foreground-400">注册用户突破50万，上线真人荷官直播功能</div>
                    </div>
                    <div className="flex gap-4">
                      <div className="shrink-0 w-16 text-sm font-heading font-bold text-primary-400">2019</div>
                      <div className="text-sm text-foreground-400">获得英国GC认证，注册用户突破100万</div>
                    </div>
                    <div className="flex gap-4">
                      <div className="shrink-0 w-16 text-sm font-heading font-bold text-primary-400">2021</div>
                      <div className="text-sm text-foreground-400">推出体育竞技和电竞专区，游戏数量突破300款</div>
                    </div>
                    <div className="flex gap-4">
                      <div className="shrink-0 w-16 text-sm font-heading font-bold text-primary-400">2023</div>
                      <div className="text-sm text-foreground-400">推出4K超清真人直播，注册用户突破200万</div>
                    </div>
                    <div className="flex gap-4">
                      <div className="shrink-0 w-16 text-sm font-heading font-bold text-primary-400">2024</div>
                      <div className="text-sm text-foreground-400">荣获"年度最佳在线娱乐平台"大奖，行业影响力持续提升</div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'reputation' && (
              <div className="space-y-8 animate-in fade-in duration-300">
                <div className="bg-background-900 rounded-xl border border-background-700/30 p-6 md:p-8">
                  <h2 className="text-xl font-heading font-bold text-foreground-50 mb-4">安全认证</h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="flex items-start gap-3 p-4 bg-background-800/30 rounded-xl">
                      <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-accent-500/10">
                        <i className="ri-shield-check-line text-accent-400 text-lg"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">PAGCOR认证</h3>
                        <p className="text-xs text-foreground-500 mt-1 leading-relaxed">获得菲律宾娱乐博彩公司（PAGCOR）颁发的合法运营牌照。</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3 p-4 bg-background-800/30 rounded-xl">
                      <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-accent-500/10">
                        <i className="ri-lock-line text-accent-400 text-lg"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">SSL加密</h3>
                        <p className="text-xs text-foreground-500 mt-1 leading-relaxed">采用256位SSL加密技术，达到国际银行安全级别标准。</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3 p-4 bg-background-800/30 rounded-xl">
                      <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-accent-500/10">
                        <i className="ri-shuffle-line text-accent-400 text-lg"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">RNG认证</h3>
                        <p className="text-xs text-foreground-500 mt-1 leading-relaxed">所有游戏采用经iTech Labs认证的随机数生成器，确保公平。</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3 p-4 bg-background-800/30 rounded-xl">
                      <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-accent-500/10">
                        <i className="ri-verified-badge-line text-accent-400 text-lg"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">GC认证</h3>
                        <p className="text-xs text-foreground-500 mt-1 leading-relaxed">获得英国博彩委员会（Gambling Commission）颁发的运营认证。</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-background-900 rounded-xl border border-background-700/30 p-6 md:p-8">
                  <h2 className="text-xl font-heading font-bold text-foreground-50 mb-4">公平保障</h2>
                  <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
                    金沙娱乐将公平性视为平台的生命线。我们采取以下措施确保每一位玩家都能在公平的环境中游戏：
                  </p>
                  <ul className="space-y-3 text-sm text-foreground-400">
                    <li className="flex items-start gap-2">
                      <div className="w-5 h-5 shrink-0 flex items-center justify-center mt-0.5">
                        <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
                      </div>
                      <span>所有电子游戏采用经过第三方认证的随机数生成器（RNG），每局结果完全随机且不可预测</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div className="w-5 h-5 shrink-0 flex items-center justify-center mt-0.5">
                        <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
                      </div>
                      <span>真人荷官游戏全程高清直播，玩家可实时观看荷官的每一个操作，确保透明公正</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div className="w-5 h-5 shrink-0 flex items-center justify-center mt-0.5">
                        <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
                      </div>
                      <span>体育竞技采用国际标准赔率体系，实时同步全球主流博彩公司的赔率数据</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div className="w-5 h-5 shrink-0 flex items-center justify-center mt-0.5">
                        <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
                      </div>
                      <span>定期接受第三方独立机构审计，审计报告公开透明</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div className="w-5 h-5 shrink-0 flex items-center justify-center mt-0.5">
                        <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
                      </div>
                      <span>设有专门的公平性监督委员会，24小时监控平台运营数据</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-background-900 rounded-xl border border-background-700/30 p-6 md:p-8">
                  <h2 className="text-xl font-heading font-bold text-foreground-50 mb-4">行业荣誉</h2>
                  <div className="space-y-4">
                    <div className="flex items-center gap-4 p-4 bg-background-800/30 rounded-xl">
                      <div className="w-12 h-12 shrink-0 flex items-center justify-center rounded-lg bg-primary-500/10">
                        <i className="ri-trophy-line text-primary-400 text-xl"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">2024年度最佳在线娱乐平台</h3>
                        <p className="text-xs text-foreground-500 mt-1">亚洲在线娱乐行业协会颁发</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-4 p-4 bg-background-800/30 rounded-xl">
                      <div className="w-12 h-12 shrink-0 flex items-center justify-center rounded-lg bg-primary-500/10">
                        <i className="ri-star-line text-primary-400 text-xl"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">2023年度最受玩家喜爱平台</h3>
                        <p className="text-xs text-foreground-500 mt-1">国际博彩行业峰会颁发</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-4 p-4 bg-background-800/30 rounded-xl">
                      <div className="w-12 h-12 shrink-0 flex items-center justify-center rounded-lg bg-primary-500/10">
                        <i className="ri-award-line text-primary-400 text-xl"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">2022年度最佳技术创新奖</h3>
                        <p className="text-xs text-foreground-500 mt-1">亚太在线娱乐行业论坛颁发</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'contact' && (
              <div className="space-y-8 animate-in fade-in duration-300">
                <div className="bg-background-900 rounded-xl border border-background-700/30 p-6 md:p-8">
                  <h2 className="text-xl font-heading font-bold text-foreground-50 mb-6">联系方式</h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 shrink-0 flex items-center justify-center rounded-xl bg-primary-500/10">
                        <i className="ri-customer-service-line text-primary-400 text-xl"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">在线客服</h3>
                        <p className="text-xs text-foreground-500 mt-1 leading-relaxed">7×24小时在线客服，随时随地为您解答问题。响应速度快，服务专业周到。</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 shrink-0 flex items-center justify-center rounded-xl bg-primary-500/10">
                        <i className="ri-phone-line text-primary-400 text-xl"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">VIP客服热线</h3>
                        <p className="text-xs text-foreground-500 mt-1 leading-relaxed">VIP专属客服热线：400-888-9999。VIP会员享有专属客服经理一对一服务。</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 shrink-0 flex items-center justify-center rounded-xl bg-primary-500/10">
                        <i className="ri-mail-line text-primary-400 text-xl"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">客服邮箱</h3>
                        <p className="text-xs text-foreground-500 mt-1 leading-relaxed">service@jinshaentertainment.com。我们会在24小时内回复您的邮件。</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 shrink-0 flex items-center justify-center rounded-xl bg-primary-500/10">
                        <i className="ri-telegram-line text-primary-400 text-xl"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-200">Telegram客服</h3>
                        <p className="text-xs text-foreground-500 mt-1 leading-relaxed">关注金沙娱乐官方Telegram频道，获取最新优惠信息和平台动态。</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-background-900 rounded-xl border border-background-700/30 p-6 md:p-8">
                  <h2 className="text-xl font-heading font-bold text-foreground-50 mb-4">商务合作</h2>
                  <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
                    金沙娱乐欢迎各类商务合作机会。如果您是游戏开发商、支付服务商或市场合作伙伴，欢迎与我们联系。
                  </p>
                  <p className="text-sm text-foreground-500">
                    商务合作邮箱：biz@jinshaentertainment.com
                  </p>
                </div>

                <div className="bg-background-900 rounded-xl border border-background-700/30 p-6 md:p-8">
                  <h2 className="text-xl font-heading font-bold text-foreground-50 mb-4">常见问题</h2>
                  <div className="space-y-4">
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-200 mb-2">金沙娱乐平台是否安全可靠？</h3>
                      <p className="text-xs text-foreground-500 leading-relaxed">
                        金沙娱乐采用国际领先的256位SSL加密技术和多重身份验证系统，所有游戏均使用经过认证的随机数生成器（RNG），确保平台的安全性和公平性。平台定期接受第三方独立机构的审计，并获得多项行业权威认证。
                      </p>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-200 mb-2">金沙娱乐提供哪些游戏类型？</h3>
                      <p className="text-xs text-foreground-500 leading-relaxed">
                        金沙娱乐提供电子游戏（老虎机、桌面游戏等）、真人荷官（百家乐、轮盘、骰宝等）、体育竞技（足球、篮球、网球等）、彩票游戏（时时彩、快乐8等）和电竞竞技（LOL、DOTA2、CS:GO等）五大游戏类型，满足不同玩家的娱乐需求。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}